import { CHECK_GIFTCARD_BALANCE, CLEAR_GIFTCARD_BALANCE, RESET_GIFTCARDBALANCE, GET_GIFTCARD_DETAILS } from '../../constants';
export function checkGiftCardBalance(payload) {
    return {
        type: CHECK_GIFTCARD_BALANCE,
        payload,
    };
}
export function clearGiftcardBalanceAction() {
    return {
        type: CLEAR_GIFTCARD_BALANCE,
    };
}
export function resetGiftcardCheckBal() {
    return {
        type: RESET_GIFTCARDBALANCE,
    };
}
export function getGiftCardDetails(payload) {
    return {
        type: GET_GIFTCARD_DETAILS,
        payload,
    };
}
